import React, { forwardRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { Chip } from '@material-ui/core';

import IconClose from 'src/assets/icons/Close';
import { useStyles } from './useStyles';

export const CustomChip = forwardRef(
  ({ className, classes, label, interactive, inactive, deleteIcon, ...restProps }, ref) => {
    const styles = useStyles({ classes });

    return (
      <Chip
        className={cx(
          styles.root,
          { [styles.interactive]: interactive, [styles.inactive]: inactive },
          className
        )}
        classes={{
          outlined: styles.outlined,
          label: styles.label,
          deleteIcon: styles.deleteIcon,
        }}
        ref={ref}
        label={label}
        deleteIcon={deleteIcon || <IconClose />}
        variant="outlined"
        color="primary"
        {...restProps}
      />
    );
  }
);

CustomChip.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape(),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  interactive: PropTypes.bool,
  inactive: PropTypes.bool,
  deleteIcon: PropTypes.node,
};

CustomChip.defaultProps = {
  className: null,
  classes: null,
  interactive: false,
  inactive: false,
  deleteIcon: null,
};
